export const enrollCustomerStateSelector = (state) =>
  state.customer.enrollCustomerState;

export const customerSelector = (state) => state.customer.customer;

export const pointBalanceSelector = (state) => state.customer.pointBalance;

export const isCustomerAddedToSaleSelector = (state) =>
  state.customer.isAddedToSale;

export const addCustomerToSaleStateSelector = (state) =>
  state.customer.addCustomerToSaleState;

export const removeCustomerFromSaleStateSelector = (state) =>
  state.customer.removeCustomerFromSaleState;

export const customerContextSelector = (state) => state.customer.context;

export const getCustomerStateSelector = (state) =>
  state.customer.getCustomerState;
